// import function to register Swiper custom elements
// import { register } from 'swiper/swiper-element-bundle.mjs';
// register Swiper custom elements


export function initSwiper() {
    // register();
}
  